<template>
  <div class="dialogBox">
    <el-dialog :visible.sync="addActivevis" width="80%" center :show-close="true" :close-on-click-modal="false" @close="close">
      <el-row style="margin-top: 20px;">
        <div>
          <el-col :span="10" class="leftTable">
            <div class="leftTitle">单位</div>
            <!--<el-input v-model="searchValue" placeholder="请输入" class="input-with-select" size="mini" suffix-icon="el-icon-search" style="margin: 10px 0;" />-->

            <div style="height: 205px">
              <el-table :data="leftTableData" max-height="258" size="mini" :show-header="showHeader" style="width: 100%" :header-cell-style="tableHeaderColor" @selection-change="checkAll">
                <el-table-column type="selection" width="50" />
                <el-table-column prop="name" label="单位" />
              </el-table>
            </div>
          </el-col>
          <el-col :span="4" class="btnMove">
            <div>
              <div class="opSetting" @click="handelSelect">
                <el-button icon="el-icon-d-arrow-right" :disabled="nowSelectData.length?false:true" size="mini" type="primary" />
              </div>
              <div class="spacing" @click="handleRemoveSelect">
                <el-button icon="el-icon-d-arrow-left" :disabled="nowSelectRightData.length?false:true" size="mini" type="primary" />
              </div>
            </div>
          </el-col>
          <el-col :span="10" class="leftTable">
            <div style="background-color: #fff;height: 290px;">
              <el-table :data="rightTableData" max-height="290" size="mini" :header-cell-style="tableHeaderColor" @selection-change="checkRightAll">
                <el-table-column type="selection" width="50" />
                <el-table-column prop="name" label="单位名称" />
                <el-table-column prop="label" label="单位编号">
                  <template slot-scope="scope">
                    <el-input v-model="selectCode[scope.row.name+'a']" type="text" placeholder="请输入编号" size="mini" @input="selectInput(scope.row.name)" />
                  </template>
                </el-table-column>
                <el-table-column prop="role" label="单位类型">
                  <template slot-scope="scope">
                    <el-select v-model="selectDataList[scope.row.name+'a']" size="mini" placeholder="请选择" @change="selectRole(scope.row.name)">
                      <el-option
                        v-for="item in unitAllList"
                        :key="item.text"
                        :label="item.value"
                        :value="item.value"
                      />
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </div>
      </el-row>
      <div class="footer">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="mini" @click="submit" v-preventReClick>确 定</el-button>
          <el-button size="mini" @click="cancel">取 消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { leadingIn } from '@/api/company'
import { getProjectId } from '@/utils/auth'
export default {
  name: 'ImportUnit',
  props: {
    dialogVisible: {
      type: Boolean
    },
    dataObj: {
      type: Array
    }
  },
  data() {
    return {
      addActivevis: false,
      value: [1],
      roleValue: [],
      selectVal: '',
      proId: '',
      tableData: [],
      showHeader: false, // 是否显示表头
      searchValue: '', // 搜索值
      leftTableData: [], // 左边表格数据
      rightTableData: [], // 右边表格数据
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      selectDataList: [], // 下拉框选中的值
      selectCode: [],
      unitAllList: [
        { text: '研究中心', value: '研究中心' },
        { text: '数据管理单位', value: '数据管理单位' },
        { text: '数据统计单位', value: '数据统计单位' },
        { text: '申办方', value: '申办方' },
        { text: '平台供应商', value: '平台供应商' },
        { text: '合同研究组织', value: '合同研究组织' },
        { text: '药物运输单位', value: '药物运输单位' },
        { text: '其他', value: '其他' }
      ],
      code: ''
    }
  },
  watch: {
    dialogVisible(newVal) {
      this.addActivevis = newVal
    },
    'dataObj': function() {
      // console.info(this.dataObj)
      this.leftTableData = this.dataObj
    }
  },
  created() {
    this.proId = getProjectId()
  },
  methods: {
    close() {
      this.nowSelectData = []
      this.rightTableData = []
      this.selectDataList = []
      this.selectCode = []
      this.addActivevis = false
      this.$emit('dialogHide')
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) { // 改表头颜色
      if (rowIndex === 0) {
        return 'background-color: #D6E4FF;color: #666;'
      }
    },
    checkAll(val) {
      this.nowSelectData = val
    },
    checkRightAll(val) {
      this.nowSelectRightData = val
    },
    // 移除
    handelSelect() {
      this.rightTableData = this.handleConcatArr(this.rightTableData, this.nowSelectData)
      this.handleRemoveTabList(this.nowSelectData, this.leftTableData)
      this.nowSelectData = []
    },
    // 添加
    handleRemoveSelect() {
      this.leftTableData = this.handleConcatArr(this.leftTableData, this.nowSelectRightData)
      this.handleRemoveTabList(this.nowSelectRightData, this.rightTableData)
      this.nowSelectRightData = []
    },
    selectRole(name) {
      this.rightTableData.map(item => {
        if (item.name === name) {
          item.roleId = this.selectDataList[name+'a']
        }
      })
    },
    selectInput(name) {
      this.rightTableData.map(item => {
        if (item.name === name) {
          item.code = this.selectCode[name+'a']
        }
      })
    },
    handleConcatArr(a, b) {
      let arr = []
      arr = arr.concat(a, b)
      console.log(arr)
      return arr
    },
    handleRemoveTabList(isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i] === originalArr[k]) {
              originalArr.splice(k, 1)
            }
          }
        }
      }
    },
    validate() {
      if (!this.rightTableData || this.rightTableData.length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择单位!'
        })
        return false
      }
      console.log(this.rightTableData)
      console.log(1231321)
      const booleanRoles = this.rightTableData.some(item => item.roleId === null || item.roleId === '' || item.roleId === undefined)
      const codeBool = this.rightTableData.some(item => item.code === null || item.code === '' || item.code === undefined)
      if (codeBool) {
        this.$message({
          type: 'warning',
          message: '请填写单位编号!'
        })
        return false
      }
      if (booleanRoles) {
        this.$message({
          type: 'warning',
          message: '请选择单位类型!'
        })
        return false
      }
      return true
    },

    submit() {
      if (this.validate()) {
        const o = this.rightTableData.map(item => {
          const obj = {}
          obj.name = item.name
          obj.style = item.roleId
          obj.code = item.code
          return obj
        })
        const params = {
          project_id: this.proId,
          unit_list: o
        }
        console.log(params)
        leadingIn(params).then(res => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.cancel()
          } else {
            this.$message(res.msg)
          }
        }).catch(res => {
          console.log(res.msg)
        })
      }
    },
    cancel() {
      this.nowSelectData = []
      this.rightTableData = []
      this.selectDataList = []
      this.selectCode = []
      this.addActivevis = false
      this.$parent.getUnit()
    }
  }
}
</script>

<style lang="scss">
  .box{
    .tableBox {
      width: 100%;
      height: 300px;
      overflow-y: scroll;
    }
  }
  .dialogBox{
    .footer{
      text-align: center;
      margin-top: 30px;
    }
    .leftTable{
      background-color: #F0F5FF;
      padding: 5px;
      min-height: 300px;
      .leftTitle{
        text-align: center;
        font-size: 12px;
        color: #595959;
        font-weight: bold;
        background-color: #D6E4FF;
        padding: 10px 0;
      }
    }
    .btnMove{
      margin-top: 10%;
      text-align: center;
      .opSetting{
        margin: 10px 0;
      }
    }
    .transferBox{
      min-height: 300px;
      .el-transfer{
        .el-transfer-panel{
          width: 358px!important;
        }
      }
    }
  }
</style>

